import React from 'react';

export default function NilVisionLogo({ size = 28, showWordmark = true }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div style={{ position: 'relative', flexShrink: 0 }}>
        <div style={{
          position: 'absolute', inset: 0,
          background: 'radial-gradient(ellipse at center, rgba(91,33,182,0.5) 0%, transparent 70%)',
          borderRadius: '50%', filter: 'blur(4px)',
        }} />
        <img
          src="/nilvision-logo-gradient-background.png"
          alt="NILVISION"
          style={{ width: size, height: size, objectFit: 'contain', position: 'relative', zIndex: 1, display: 'block' }}
          onError={(e) => { e.currentTarget.src = '/nilvision-logo-gradient-backdrop.png'; }}
        />
      </div>
      {showWordmark && (
        <span style={{
          fontWeight: 800,
          fontSize: size < 26 ? '0.95rem' : '1rem',
          letterSpacing: '0.08em',
          background: 'linear-gradient(135deg, #fff 0%, #c4b5fd 55%, #93c5fd 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          NILVISION
        </span>
      )}
    </div>
  );
}
